module.exports = require("core-js/library/fn/object/get-own-property-descriptor");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/object/get-own-property-descriptor.js
// module id = 1644
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 20 21 22 25